import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingDetailsComponent } from './booking-details.component';
import { BookingInformationModule } from 'libraries/component/booking-information/booking-information.module';
import { BookingDetailsRouting } from './booking-details.routing';
import { SashaBreadcrumbModule } from 'app_sasha/shared/components/breadcrumb/sasha-breacrumb.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { AirBookingResourceModule } from 'libraries/service/resources/air-booking/air-booking-resource.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';
import {
    LuggageUnitModule
} from "../../../libraries/component/booking-information/components/booking-price-card/pipes/luggage-unit.module";

@NgModule({
    imports: [
        CommonModule,
        BookingInformationModule,
        SashaBreadcrumbModule,
        NotificationModule,
        BookingDetailsRouting,
        AirBookingResourceModule,
        TitleServiceModule,
        LuggageUnitModule
    ],
    declarations: [
        BookingDetailsComponent
    ]
})
export class BookingDetailsModule { }
